import { render, staticRenderFns } from "./LinkBubbleView.vue?vue&type=template&id=a36cdc3c&scoped=true"
import script from "./LinkBubbleView.vue?vue&type=script&lang=js"
export * from "./LinkBubbleView.vue?vue&type=script&lang=js"
import style0 from "./LinkBubbleView.vue?vue&type=style&index=0&id=a36cdc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36cdc3c",
  null
  
)

export default component.exports